<template>
  <a-spin :spinning="spinning" class="spinning_box">
    <div class="TeacherCorrection">
      <div class="TeacherCorrection_title">
        <TitlesImg :type="record.titleImgType" />
        <span class="TeacherCorrection_Span">{{ record.title }} </span>
      </div>
      <div class="dataScreen_content_4box_top_right_content">
        <div class="dataScreen_content_right_top_box">
          <div class="dataScreen_content_right_top_box_left">
            <img src="../../assets/img/imgStaly1/warn_img.png" class="dataScreen_content_right_top_box_left_img" alt="">
            <div class="dataScreen_content_right_top_box_left_box">
              <span class="dataScreen_content_right_top_box_left_box_span" style="font-size:1em;">本周公示</span>
              <span class="dataScreen_content_right_top_box_left_box_span1">
                <span style="color: #F6A832; font-size:1.5em;">{{teacherWarnNum}}</span>
                <span style="font-size:1em;">起</span>
              </span>
            </div>
          </div>
          <div class="dataScreen_content_right_top_box_right">
            <img src="../../assets/img/imgStaly1/warn_bg.png" class="dataScreen_content_right_top_box_right_img" alt="">
            <div class="dataScreen_content_right_top_box_right_box">
              <vue-seamless-scroll v-if="teacherWarnList.length>=1" :data="teacherWarnList" @ScrollEnd="ScrollEnd"
                class="seamless-warp" :class-option="defaultOption">
                <ul class="ul-scoll">
                  <li v-for="(item, index) in teacherWarnList" class="ul_scoll_li" :key="index">
                    <div class="item TeacherCorrectionBox">
                      <span class="dataScreen_content_right_top_box_right_box_box_left"></span>
                      <span class="dataScreen_content_right_top_box_right_box_box_span5"
                        style="width: calc(100% - 20px);">{{item}}</span>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
  import TitlesImg from '@/components/CustomModule/TitlesImg.vue'
  import {
    bigscreenWarningTeacher
  } from '@/api/other'
  import vueSeamlessScroll from 'vue-seamless-scroll'
  export default {
    name: "TeacherCorrection",
    props:{
      record: {
        type: Object
      },
      currentSubSchoolId: {
        type: String
      }
    },
    watch: {
      currentSubSchoolId: function (e, n) {
        console.log(e, n);
      },
      warnType: function (e, n) {
        console.log(e, n);
      },
    },
    components: {
      vueSeamlessScroll,
      TitlesImg
    },
    // 监听属性 类似于data概念      
    computed: {
      defaultOption() {
        return {
          step: this.record.step ? this.record.step : 1, // 数值越大速度滚动越快   
          limitMoveNum: this.record.limitMoveNum ? this.record.limitMoveNum : 6, // 开始无缝滚动的数据量 this.dataList.length             
          hoverStop: false, // 是否开启鼠标悬停stop          
          direction: 1, // 0向下 1向上 2向左 3向右      
          openWatch: true, // 开启数据实时监控刷新dom                
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1             
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3      
          waitTime: 1000 // 单步运动停止的时间(默认值1000ms) 
        }
      }
    },
    data() {
      return {
        spinning: false,
        teacherWarnNum: '',
        teacherWarnList: []
      };
    },
    methods: {
      loadData(sType) {
        this.spinning = true
        bigscreenWarningTeacher(
          {
            disciplineIds: this.record.xuekeIds.join(','),
            gradeIds: this.record.gradeIds.join(','),
            subSchoolId: this.currentSubSchoolId,
            useFakeData: this.record.useFakeData
          },
          (resp) => {
            const resData = resp.data
            this.teacherWarnNum = resData.length
            this.teacherWarnList = resData
            this.spinning = false
          },
          (err) => {
            console.log('err', err)
            this.$message.error(err)
            this.spinning = false
          }
        )
      },
      ScrollEnd() {
        console.log("ScrollEnd")
      }
    },
    mounted() {
      this.loadData(0)
    }
  };

</script>

<style scoped>
.TeacherCorrection {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.TeacherCorrectionBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
}
.TeacherCorrection_title {
  position: relative;
  height: 15%;
}
.TeacherCorrection_Img {
  width: 100%;
}
.TeacherCorrection_Span {
  display: flex;
  align-items: center;
  position: absolute;
  color: #CCECF9;
  font-size: 1em;
  top: 0;
  bottom: 0;
  left: 5%;
  margin: auto;
  margin-left: 5%;
}
</style>
